//path: src\store\rootState.ts

import { combineReducers } from 'redux';
import sceneNameReducer from '../features/sceneName/sceneNameReducer';
import sceneAssetsReducer from '../features/sceneAssets/sceneAssetsReducer';
import editorSelectionReducer from '../features/editorSelection/editorSelectionReducer';
import keyframesReducer from '../features/keyframes/keyframesSlice';
import clipsReducer from '../features/clips/clipsSlice';
import triggersReducer from '../features/triggers/triggersSlice';
import triggerPreviewReducer from '../features/triggerPreview/triggerPreviewSlice';
import triggerAuthoringReducer from '../modules/triggerAuthoring/triggerAuthoringSlice';
import uiElementsReducer from '../features/uiElements/uiElementsSlice';

const rootReducer = combineReducers({
  sceneName: sceneNameReducer,
  sceneAssets: sceneAssetsReducer,
  editorSelection: editorSelectionReducer,
  keyframes: keyframesReducer,
  clips: clipsReducer,
  triggers: triggersReducer,
  triggerPreview: triggerPreviewReducer,
  triggerAuthoring: triggerAuthoringReducer,
  uiElements: uiElementsReducer
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
